export const RENOVATION_PROJECT_STEP_ORDER = [
  "PROPERTY_INFORMATION",
  "PRE_ASSESSMENT",
  "RENOVATION_PLAN",
  "ENERGY_PERFORMANCE_CERTIFICATE",
  "WORKS_BUDGET",
  "SUBSIDIES_GRANTS",
  "FINANCING",
  "MONITORING",
];

export function isPropertyInfoComplete(project) {
  const property = project?.property || {};
  const homeowner = project?.homeowner || {};
  const oss = project?.oss || {};

  const hasEpcFile = Boolean(
    property.has_epc_document ||
    property.epc_document?.file_storage_key ||
    property.epc_document?.file_url ||
    property.epc_document?.download_url,
  );

  return Boolean(
    (property.full_address || property.address || project?.property_address) &&
    property.city &&
    property.postal_code &&
    property.country &&
    property.property_type &&
    property.building_condition &&
    property.surface_sqm &&
    property.epc_rating_current &&
    property.epc_rating_target &&
    hasEpcFile &&
    (homeowner.full_name || project?.homeowner_name) &&
    (homeowner.email || project?.homeowner_email) &&
    (oss.organisation_name || project?.oss_name) &&
    (oss.contact_email || project?.oss_contact_email),
  );
}

export function getDisplayStepStatus(step, project) {
  if (
    step?.step_code === "PROPERTY_INFORMATION" &&
    isPropertyInfoComplete(project)
  ) {
    return "COMPLETED";
  }

  return step?.status || "NOT_STARTED";
}

export function getCompletedProgress(project) {
  const completedStepCodes = new Set();

  (project?.steps || []).forEach((step) => {
    if (getDisplayStepStatus(step, project) === "COMPLETED") {
      completedStepCodes.add(step.step_code);
    }
  });

  if (isPropertyInfoComplete(project)) {
    completedStepCodes.add("PROPERTY_INFORMATION");
  }

  if (!completedStepCodes.size) return 0;

  const latestCompletedIndex = Math.max(
    ...Array.from(completedStepCodes)
      .map((code) => RENOVATION_PROJECT_STEP_ORDER.indexOf(code))
      .filter((idx) => idx >= 0),
  );

  return Math.round(
    ((latestCompletedIndex + 1) / RENOVATION_PROJECT_STEP_ORDER.length) * 100,
  );
}

export function getLatestCompletedStep(project) {
  const completedSteps = [];

  (project?.steps || []).forEach((step) => {
    if (getDisplayStepStatus(step, project) === "COMPLETED") {
      completedSteps.push(step);
    }
  });

  if (isPropertyInfoComplete(project)) {
    completedSteps.push({
      step_code: "PROPERTY_INFORMATION",
      status: "COMPLETED",
    });
  }

  return (
    completedSteps.sort(
      (a, b) =>
        RENOVATION_PROJECT_STEP_ORDER.indexOf(b.step_code) -
        RENOVATION_PROJECT_STEP_ORDER.indexOf(a.step_code),
    )[0] || null
  );
}

export function getDisplayProjectStatus(project) {
  const steps = project?.steps || [];

  const propertyStep = steps.find(
    (step) => step.step_code === "PROPERTY_INFORMATION",
  );

  const preAssessmentStep = steps.find(
    (step) => step.step_code === "PRE_ASSESSMENT",
  );

  const propertyCompleted =
    getDisplayStepStatus(propertyStep, project) === "COMPLETED";

  const preAssessmentCompleted =
    getDisplayStepStatus(preAssessmentStep, project) === "COMPLETED";

  if (propertyCompleted && preAssessmentCompleted) {
    return "IN_PROGRESS";
  }

  return "PLANNING";
}
